
<div class="notification" (click)="open()">
  <div class="img">
    <img [src]="photo"  />
  </div>
  
  <div class="content">
    <p class="title">{{ notificacion.title }}</p>
    <p class="desc">
      {{ description }}
    </p>
  </div>
  <div class="date">
    <p>{{ timeAgo(notificacion.createdAt, "es") }}</p>
  </div>
  <div class="unread">
    <button
      (click)="changeMark($event)"
      [matTooltip]="toolTipText"
      matTooltipPosition="left"
      class="unread-btn"
    >
      <div class="dot" *ngIf="isUnread"></div>
    </button>
  </div>
</div>
